window.addEventListener("DOMContentLoaded", () => {
    (() => {
        const tabs = [...document.querySelectorAll(".multi-tab-faqs-tab")];
        const allFaqs = [...document.querySelectorAll(".multi-tab-faqs-item")];

        tabs?.forEach((tab) => {
            tab?.addEventListener("click", () => {
                const tabName = tab?.innerHTML;

                tabs?.forEach((t) => t?.classList?.remove("active"));
                tab?.classList?.add("active");

                allFaqs?.forEach((faq) => {
                    const isFromTab =
                        faq?.getAttribute("data-tab")?.trim()?.toLowerCase() === tabName?.trim()?.toLowerCase();
                    if (isFromTab) faq?.classList?.add("active");
                    else faq?.classList?.remove("active");
                });
            });
        });
    })();
});
